import { routeIsPublic } from "@/services/routeService"
import router from "@/routes";

const loadOnStartup = [
    "authentication",
    "schema"
];

const loadOnLoginChange = [
    "localisation",
    "stripe"
];

const allLoadableStores = [
    ...loadOnStartup,
    ...loadOnLoginChange
];

async function dispatchAll(stores, action, dispatch) {
    const promises = stores
        .map(store => `${store}/${action}`)
        .map(actionPath => dispatch(actionPath, null, { root: true }));

    promises.push(new Promise((resolve, reject) => {
        router.onReady(resolve, reject)
    }))

    await Promise.all(promises);
}

const actions = {
    async onStartup({ dispatch }) {
        await dispatchAll(loadOnStartup, "load", dispatch);
    },

    async onLoginChange({ dispatch }, isLoggedIn) {
        const action = isLoggedIn ? "load" : "clear";
        await dispatchAll(loadOnLoginChange, action, dispatch);
    }
};

export const getters = {
    isLoaded: (_state, _getters, rootState) => {
        const stores = routeIsPublic(rootState.router.currentRoute) ?
            loadOnStartup :
            allLoadableStores;

        return stores.every(store => rootState[store].isLoaded)
    }
};

export const load = {
    namespaced: true,
    state: { },
    actions,
    getters
}
